<template>
    <div class="w-full">
        <div class="p-4">
            <CorrectIncorrectIcon :is-correct="true" /> {{ question.options.numerator }} /
            {{ question.options.denominator }}
        </div>
        <div class="text-sm text-gray-400">
            <span v-if="question.options.accepts_equivalent">
                {{ $t('messages.accepts_equivalent_explanation') }}
            </span>
            <span v-else>
                {{ $t('messages.does_not_accepts_equivalent_explanation') }}
            </span>
        </div>
    </div>
</template>

<script>
import CorrectIncorrectIcon from '@/components/Quiz/CorrectIncorrectIcon.vue';

export default {
    name: 'QuestionMathFractionViewOnly',
    components: {
        CorrectIncorrectIcon,
    },
    props: {
        question: {
            required: true,
        },
    },
};
</script>
